import { HttpErrorResponse, HttpHeaders, HttpParams, HttpParamsOptions } from '@angular/common/http';

type ValueParameter = Parameters<HttpParams['append']>[1];
type AppendAllParameters = Parameters<HttpParams['appendAll']>[0];

export interface NkError {
  message: string;
  error_key?: string;
}

export interface NkHttpError extends HttpErrorResponse {
  error: NkError;
}

export function isNkHttpError(item: unknown): item is NkHttpError {
  return (
    !!item && (item as NkHttpError).hasOwnProperty('error') && (item as NkHttpError).error.hasOwnProperty('message')
  );
}

export enum NkTaskStatusEntity {
  Failed = 'failed',
  Done = 'done',
}

export interface NkJobEntity {
  error: NkHttpError;
  job_status_key: NkTaskStatusEntity;
  task_uuid: string;
  uuid: string;
}

export class NkHttpParams extends HttpParams {
  private static _convert(params: HttpParams): NkHttpParams {
    const fromObject: HttpParamsOptions['fromObject'] = {};
    for (const key of params.keys()) {
      const values = params.getAll(key);
      if (values !== null) {
        fromObject[key] = values;
      }
    }
    return new NkHttpParams({ fromObject: fromObject });
  }

  public appendIf(truthyObject: unknown, param: string, value: ValueParameter): NkHttpParams {
    return truthyObject ? NkHttpParams._convert(super.append(param, value)) : this;
  }

  public override append(param: string, value: ValueParameter): NkHttpParams {
    return NkHttpParams._convert(super.append(param, value));
  }

  public override appendAll(params: AppendAllParameters): NkHttpParams {
    return NkHttpParams._convert(super.appendAll(params));
  }

  public override set(param: string, value: string | number | boolean): NkHttpParams {
    return NkHttpParams._convert(super.set(param, value));
  }

  public override delete(param: string, value?: string | number | boolean): NkHttpParams {
    return NkHttpParams._convert(super.delete(param, value));
  }
}

export class RequestOptions {
  constructor(
    public headers?: HttpHeaders,
    public observe?: 'body',
    public params?: HttpParams,
    public reportProgress?: boolean,
    public responseType?: 'json',
    public withCredentials?: boolean,
    public body?: unknown,
  ) {}
}
